<template>
  <v-card elevation="1" class="transport" style="width: 100%" flat tile>
    <v-card-actions>
      <h4 class="pl-4">{{title}}</h4>
      <v-spacer />
      <v-btn icon @click="show = !show">
        <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
      </v-btn>
    </v-card-actions>
    <v-divider />
    <v-expand-transition>
      <div class="grey lighten-4" v-show="show">
        <v-row  class="pa-4">
          <v-col class="d-flex py-0 mb-2" cols="12">
            <v-select 
              v-model="selectedCity"
              :items="handleItems('transport_departure_city').items.length ? handleItems('transport_departure_city').items : selectedCity ? [{value: selectedCity}] : []" 
              item-text="value" 
              :label="handleItems('transport_departure_city').label" 
              class="white" 
              :menu-props="{ bottom: true, offsetY: true }" 
              hide-details 
              dense 
              outlined
              @keydown="handleKeyboardInput"
              @input="handleCityFilter"
            ></v-select>
          </v-col>
          <v-col class="d-flex py-0" cols="12" >
            <v-select
              v-model="selectedTransport"
              :items="handleItems('transport_type').items.length ? handleItems('transport_type').items : selectedTransport ? [{value: selectedTransport}] : []" 
              item-text="value" 
              :label="handleItems('transport_type').label" 
              class="white" 
              :menu-props="{ bottom: true, offsetY: true }" 
              hide-details 
              dense 
              outlined
              @keydown="handleKeyboardInput"
              @input="handleTransportFilter"
            ></v-select>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
export default {
  props: {
    title: String,
    fields: Array,
  },
  data: () => ({
    show: false,
    selectedType: false,
    selectedCity: null,
    selectedTransport: null,
    keyPressed: false
  }),
  computed: {
    transport() {
      return this.$store.state.filters.find(filter => filter.field === 'transport_type');
    },
    city() {
      return  this.$store.state.filters.find(filter => filter.field === 'transport_departure_city');
    },
  },
  methods: {
    handleKeyboardInput() {
      this.keyPressed = true;
    },
    handleItems(fieldName) {
      let field = this.fields.find(f => f.field === fieldName);
      return field;
    },
    handleCityFilter() {
      if(this.keyPressed){
        this.keyPressed = false;
        return;
      }

      let filterActive = this.$store.state.filters.find(item => item.field === 'transport_departure_city' && item.value === this.selectedCity);
      if(this.selectedCity && !filterActive){
        this.$store.commit('setFilter', {
          field: 'transport_departure_city',
          value: this.selectedCity,
          id: `transport_departure_city-${this.selectedCity}`,
          breadcrumbs: true,
          title: "Depart de",
          type: "value"
        })
      } else {
        this.$store.commit('removeFilter', {
          id: `transport_departure_city-${this.selectedCity}`
        })
      }
    },
    handleTransportFilter() {
      if(this.keyPressed){
        this.keyPressed = false;
        return;
      }

      let filterActive = this.$store.state.filters.find(item => item.field === 'transport_type' && item.value === this.selectedTransport);
      if(this.selectedTransport && !filterActive){
        this.$store.commit('setFilter', {
          field: 'transport_type',
          value: this.selectedTransport,
          id: `transport_type-${this.selectedTransport}`,
          breadcrumbs: true,
          title: "Transport",
          type: "value"
        })
      } else {
        this.$store.commit('removeFilter', {
          id: `transport_type-${this.selectedTransport}`
        })
      }
    },
    // handleTypeFilter() {
    //   if(this.selectedType){
    //     // Remove all filters from field -> transport_type
    //     const filtersActive = this.$store.state.filters.filter(item => item.field === 'transport_type');
    //     if(filtersActive && filtersActive.length){
    //       filtersActive.map(filter => {
    //         this.$store.commit('removeFilter', {
    //           id: filter.id
    //         })
    //       })
    //     }
    //       console.log(this.handleItems('transport_type').items.map(item => item.value))
    //     this.$store.commit('setFilter', {
    //       field: 'transport_type',
    //       value: this.handleItems('transport_type').items.map(item => item.value),
    //       id: "transport_type",
    //       breadcrumbs: true,
    //       title: "Transport",
    //       type: "value",
    //     })
    //   } else {
    //     this.$store.commit('removeFilter', {
    //       id: "transport_type"
    //     })
    //   }
    // }
  },
  created() {
    // Init all variables if some filter was define
    let selectedCity = this.$store.state.filters.find(filter => filter.field === 'transport_departure_city');
    if(selectedCity) this.selectedCity = selectedCity.value;

    let selectedTransport = this.$store.state.filters.find(filter => filter.field === 'transport_type');
    if(selectedTransport) this.selectedTransport = selectedTransport.value;

    let selectedType = this.$store.state.filters.find(filter => filter.field === 'transport_type' && filter.value.includes('Car' && 'Train' && 'Avion'));
    if(selectedType) this.selectedType = true;

  },
  watch: {
    // Store variables
    transport(val) {
      if(!val && this.selectedType){
        this.selectedType = false;
      } 
      
      if(!val && this.selectedTransport) {
        this.selectedTransport = "";
      }
    },
    city(val) {
      if(!val && this.selectedCity){
        this.selectedCity = "";
      }
    }
  }
};
</script>

<style lang="scss">
.transport {
  .v-text-field__details {
    display: none;
  }
}
</style>